import type { RefObject } from 'react';
import React from 'react';

import { useAwsWafTokenSource } from '../../hooks';
import { AwsWafNativeToken } from '../AwsWafNativeToken';
import { AwsWafWebView } from '../AwsWafWebView';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Wires `generateAwsWafTokenRef` to the active AWS WAF token source: the native
 * AWS WAF mobile SDK, or the hidden WebView running the AWS WAF challenge script.
 */
export const AwsWafTokenGenerator = (props: Props) => {
  const { generateAwsWafTokenRef } = props;

  const tokenSource = useAwsWafTokenSource();

  if (tokenSource === 'disabled') {
    return null;
  }

  if (tokenSource === 'native-sdk') {
    return <AwsWafNativeToken generateAwsWafTokenRef={generateAwsWafTokenRef} />;
  }

  return <AwsWafWebView generateAwsWafTokenRef={generateAwsWafTokenRef} />;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  generateAwsWafTokenRef: RefObject<() => Promise<string>>;
};
